import React, { Component } from "react";
import PropTypes from 'prop-types'
// import { withStyles } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    appBar: {
        //top: 'auto',
        // height: 200,
        bottom: 0,
        backgroundColor: '#1f1f1f'
    },
    footerStyle: {
        // marginTop: 150,
        padding: 20,
        textAlign: 'center',
        color: '#fff'
    }
});

class Footer extends Component {
    render() {
        const { classes } = this.props;
        return (
            <AppBar position="static" className={classes.appBar}>
                <div className={classes.footerStyle}>
                    <Typography color='inherit'> Copyright @ Galaxy Solutions 2019 </Typography>
                </div>
            </AppBar>
        )
    }
}


Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);